export default function RecommendedSpecialist() {
  return (
    <section className="py-20 px-6 bg-[#1a1916]">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-[#f5f5f0] mb-8 text-center">
          Recommended Specialist
        </h2>
        <div className="bg-[#0e0d0b] p-8 md:p-10 rounded-lg border border-[#c9a84c]/30">
          <p className="text-[#d4d4ce] text-base leading-relaxed mb-6">
            For professional piano removals across London, we recommend{' '}
            <strong className="text-[#f5f5f0]">Piano Service North London</strong> —{' '}
            <a
              href="https://www.pianomoveteam.co.uk/piano-removals-london.html"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#c9a84c] hover:text-[#d4b85c] underline transition-colors cursor-pointer whitespace-nowrap"
            >
              piano removals London
            </a>
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 flex items-center justify-center bg-[#c9a84c]/10 rounded-lg flex-shrink-0">
                <i className="ri-calendar-line text-xl text-[#c9a84c]" aria-hidden="true"></i>
              </div>
              <div>
                <h3 className="text-[#f5f5f0] font-semibold mb-1">Established 2007</h3>
                <p className="text-[#d4d4ce] text-sm">Over 18 years of piano moving experience</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 flex items-center justify-center bg-[#c9a84c]/10 rounded-lg flex-shrink-0">
                <i className="ri-music-2-line text-xl text-[#c9a84c]" aria-hidden="true"></i>
              </div>
              <div>
                <h3 className="text-[#f5f5f0] font-semibold mb-1">30,000+ Piano Moves</h3>
                <p className="text-[#d4d4ce] text-sm">Trusted by thousands of customers</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 flex items-center justify-center bg-[#c9a84c]/10 rounded-lg flex-shrink-0">
                <i className="ri-map-pin-line text-xl text-[#c9a84c]" aria-hidden="true"></i>
              </div>
              <div>
                <h3 className="text-[#f5f5f0] font-semibold mb-1">All 32 London Boroughs</h3>
                <p className="text-[#d4d4ce] text-sm">Complete London coverage</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 flex items-center justify-center bg-[#c9a84c]/10 rounded-lg flex-shrink-0">
                <i className="ri-phone-line text-xl text-[#c9a84c]" aria-hidden="true"></i>
              </div>
              <div>
                <h3 className="text-[#f5f5f0] font-semibold mb-1">Free Fixed-Price Quote</h3>
                <p className="text-[#d4d4ce] text-sm">
                  Call{' '}
                  <a
                    href="tel:02034419463"
                    className="text-[#c9a84c] hover:text-[#d4b85c] transition-colors cursor-pointer whitespace-nowrap"
                  >
                    020 3441 9463
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}